<template>
    <div class="Calculator">
        <table class="calc" align="center">
            <!--Header-->
            <tr>
                <th colspan="4">
                    Unisense Unit Converter
                </th>
            </tr>
            <tr>
                <td class="topleft" colspan="2">
                    <label>Choose Gas: </label>
                    <div class="inputs">
                        <select class="settings" v-model="type" v-on:click="calculate">
                            <option v-for="type in types" v-bind:key="type.id" :value="type">{{ type.name }}</option>
                        </select>
                    </div>
                </td>

                <td class="topright" colspan="1">
                    <label>Choose Unit:</label>
                    <div class="inputs">
                        <select class="settings" v-model="obj.unitIn" name="Concentration" id="Concentration" v-on:click="calculate">
                            <option v-for="unit in type.units" v-bind:key="unit">{{ unit }}</option>
                        </select>
                    </div>
                </td>
                <td class="topright" colspan="1">
                    <label>Enter Concentration:</label>
                    <div class="inputs">
                        <input class="value" type="number" min="0" max="1000000" v-model="obj.gasConcentration" v-on:keyup="calculate" v-on:click="calculate"/>
                    </div>
                </td>
            </tr>

            <tr>
                <td class="leftmiddle" colspan="2">
                    <label>Temperature (°C): </label>
                    <div class="inputs">
                        <input class="value" type="number" min="0" v-model="obj.temp" v-on:keyup="calculate" v-on:click="calculate"/>
                    </div>
                </td>

                <td class="leftmiddle" colspan="1">
                    <label>Salinity (ppt, &permil;):</label>
                    <div class="inputs">
                        <input class="value" type="number" min="0" max="40" v-model="obj.salinity" v-on:keyup="calculate" v-on:click="calculate"/>
                    </div>
                </td>
                <td class="rightmiddle" colspan="1">
                    <label>Pressure (mBar):</label>
                    <div class="inputs">
                        <input colspan="2" class="value" type="number" min="0" max="2000" step="0.1" v-model="obj.pressure" v-on:keyup="calculate" v-on:click="calculate"/>
                    </div>
                </td>
            </tr>

            <tr>
                <td class="leftmiddle" colspan="3">
                    <label>OUTPUT:</label>
                    <div class="inputs">
                        <select class="settings" v-model="obj.concunit" name="unit" id="unit" v-on:click="calculate">
                            <option v-for="unit in type.units" v-bind:key="unit">{{ unit }}</option>
                        </select>
                    </div>
                </td>
            </tr>

            <tr>              <!--Results/Notes-->
                <td colspan="4">
                    <table class="one">
                        <tr>
                            <td colspan="4">
                                <component :is="type.id+'concentration'" :triggerprop="trig" :obj="obj" class="conc" :unit="obj.concunit"/>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>

            <tr>
                <td class="Notes" colspan="2">
                    <label>Moist gas in equilibrium with water</label>
                    <label v-if="type.id==='o2'" style="display: block;">
                        Note: Air saturation = 20.95 % O<sub>2</sub>
                    </label>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
/* eslint-disable */
import co2concentration from './concentrations/co2concentration.vue'
import o2concentration from './concentrations/o2concentration.vue'
import h2concentration from './concentrations/h2concentration.vue'
import n2oconcentration from './concentrations/n2oconcentration.vue'
import h2sconcentration from './concentrations/h2sconcentration.vue'

export default {
    name: 'Calculator',
    data: () => ({
        obj: {
            temp: 20,
            salinity: 0,
            pressure: 1013.25,
            gasConcentration: 1000000,
            tempType: 'Celcius',
            salinityType: '\u2030',
            pressureType: 'mBar',
            unitIn: '\u03BCmol/L',
            measure: 'water',
            proportion: 'volumen',
            concunit: '\u03BCmol/L',
            max: 30
        },
        type: {
            id: 'o2',
            name: 'Oxygen - O\u2082',
            units: null
        },
        types: [
            {
                id: 'o2',
                name: 'Oxygen - O\u2082',
                units: null
            },
            {
                id: 'h2',
                name: 'Hydrogen - H\u2082',
                units: null
            },
            {
                id: 'n2o',
                name: 'Nitrous oxide - N\u2082O',
                units: null
            },
            {
                id: 'h2s',
                name: 'Hydrogen sulfide - H\u2082S',
                units: null
            },
            {
                id: 'co2',
                name: 'Carbon dioxide - CO\u2082',
                units: null
            }
        ],
        concunit: 'umol',
        trig: 0
    }),
    mounted () {
        this.types[0].units = o2concentration.data().unitso2
        this.types[1].units = h2concentration.data().unitsh2
        this.types[2].units = n2oconcentration.data().unitsn2o
        this.types[3].units = h2sconcentration.data().unitsh2s
        this.types[4].units = co2concentration.data().unitsco2
        this.type = this.types[0]
        this.calculate()
    },
    methods: {
        calculate () {
            //This section caps the temperature depending on which gas is present
            var celcius = 30
            var kelvin = 303.15
            if (this.type === 'h2' || this.type === 'All') {
                celcius = 30
                kelvin = 303.15
            } else if (this.type === 'h2s') {
                celcius = 35
                kelvin = 308.15
            } else {
                celcius = 40
                kelvin = 313.15
            }
            if (this.obj.tempType === 'Celcius') {
                this.max = celcius
            } else if (this.obj.tempType === 'Kelvin') {
                this.max = kelvin
            }
            if (this.obj.temp > celcius && this.obj.tempType === 'Celcius') {
                this.obj.temp = celcius
            } else if (this.obj.temp > kelvin && this.obj.tempType === 'Kelvin') {
                this.obj.temp = kelvin
            }

            this.trig = this.trig + 1
        }
    },
    components: {
        co2concentration,
        h2concentration,
        h2sconcentration,
        n2oconcentration,
        o2concentration
    }
}
</script>
